import { Autocomplete, Chip, TextField, useTheme } from "@mui/material";

const SearchAndSelect = ({
  label, placeholder, options, onInputChange, onChange, value
}: {
  label: string;
  placeholder: string;
  options: Record<string, any>[];
  onInputChange: (value: string) => void;
  onChange: ((e, newValue, reason) => void);
  value: any[];
}) => {
  const theme = useTheme();
  return (
    <Autocomplete
      multiple
      value={value}
      options={options}
      filterOptions={(options) => options}
      getOptionLabel={(option) => option.label}
      getOptionKey={(option) => option.id}
      onInputChange={(_e, newValue, reason) => {
        if (reason === 'input') onInputChange(newValue);
      }}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          sx={{
            padding: '6px'
          }}
        />
      )}
      renderValue={(value, getItemProps) => {
        return value.map((option, index) => {
          const { key, ...tagProps } = getItemProps({ index });
          return (
          <Chip
            {...tagProps}
            key={option.id}
            label={option.label}
            sx={{
              backgroundColor: theme.palette.blueGrey[100],
              paddingLeft: '8px',
              '& .MuiChip-deleteIcon': {
                marginLeft: '8px',
              }
            }}
          />
        )});
      }}
      sx={{
        p: 0,
        '& .MuiTextField-root': {
          p: 0
        },
        '& .MuiInputBase-input': {
          padding: 0,
        },
        '& .MuiAutocomplete-input': {
          width: '100% !important',
        }
      }}
    />
  );
};

export default SearchAndSelect;